"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const session_1 = require("../../../../session");
const dates_and_calendars_1 = require("../dates-and-calendars");
function Definition(params) {
    return {
        getData(session = (0, session_1.getDefault)()) {
            const datesAndCalendarsProvider = new dates_and_calendars_1.DatesAndCalendarsProvider(session);
            return datesAndCalendarsProvider.getHolidays([params]);
        },
        /** @internal */
        getInstrument() {
            return (0, lodash_functions_1.cloneDeep)(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9kYXRlcy1hbmQtY2FsZW5kYXJzL2hvbGlkYXlzL2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsd0VBQThEO0FBQzlELGlEQUFpRDtBQUNqRCxnRUFBbUU7QUFFbkUsU0FBZ0IsVUFBVSxDQUFDLE1BQTZDO0lBQ3BFLE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSxvQkFBVSxHQUFFO1lBQ25DLE1BQU0seUJBQXlCLEdBQUcsSUFBSSwrQ0FBeUIsQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUV6RSxPQUFPLHlCQUF5QixDQUFDLFdBQVcsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7UUFDM0QsQ0FBQztRQUVELGdCQUFnQjtRQUNoQixhQUFhO1lBQ1QsT0FBTyxJQUFBLDRCQUFTLEVBQUMsTUFBTSxDQUFDLENBQUM7UUFDN0IsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDO0FBYkQsZ0NBYUMifQ==